import { Grid } from "@mui/material";
import React from "react";
import OfferTable from "./home/table";
import OfferHeader from "./home/header";

const Offer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OfferHeader />
      </Grid>
      <Grid item xs={12}>
        <OfferTable />
      </Grid>
    </Grid>
  );
};

export default Offer;
